import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';

interface HandbookPartner extends ListRow {
  id: number;
  name?: string;
}

const config: ListPageConfig<HandbookPartner> = {
  queryKey: 'marketing-handbook',
  title: 'Справочник партнеров',
  errorText: 'Ошибка загрузки справочника партнеров',
  fetchList: postListFetcher('/partners/default/list/'),
  rows: ['partners'],
  columns: [
    {
      header: 'id',
      render: (partner) => <Link to={`/marketing/handbook/partner/${partner.id}`}>{partner.id}</Link>,
    },
    { header: 'Наименование', render: (partner) => partner.name },
  ],
};

export const HandbookPage = () => <GenericListPage config={config} />;
